import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { parse, format } from 'url'
import ImmutablePureComponent from 'react-immutable-pure-component'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Image from '../components/image'
import Button from '../components/button'
import Counter from '../components/counter'
import { NavLink } from 'react-router-dom'
import { MODAL_EDIT_SHORTCUTS } from '../constants'
import { openModal } from '../actions/modal'

class ShortcutsAvatarList extends ImmutablePureComponent {

  handleOnOpenEditShortcutsModal = () => {
    this.props.dispatch(openModal(MODAL_EDIT_SHORTCUTS))
  }

  render() {
    const { shortcuts } = this.props

    if (!shortcuts || shortcuts.size === 0) return null

    const listItems = shortcuts.filter((s) => {
      const shortcutType = s.get('shortcut_type')
      return ['account', 'group', 'trends_rss'].indexOf(shortcutType) > -1
    })

    if (!listItems || listItems.size === 0) return null
    
    const showSettings = listItems.size > 7

    return (
      <div
        className={[
          _s.d,
          _s.px10,
          _s.pt10,
          _s.mt5,
          _s.flexRow,
          _s.w100PC,
          _s.overflowHidden,
          _s.overflowXScroll,
          _s.noScrollbar,
        ].join(' ')}
      >
        {listItems.map((s) => {
          const radiusClass = s.get('shortcut_type') === 'account' ? _s.circle : _s.radiusTiny
          return (
            <NavLink
              key={`shortcut-avatar-${s.get('id')}`}
              to={s.get('to')}
              className={[_s.d, _s.mr10, _s.h40PX, _s.w40PX, radiusClass, _s.noUnderline, _s.bgSecondary, _s.cursorPointer].join(' ')}
            >
              <Image
                cfWidthPX='40px'
                src={s.get('image')}
                className={[_s.h40PX, _s.w40PX, radiusClass, _s.overflowHidden].join(' ')}
              />
              <div className={[_s.d, _s.posAbs, _s.top0, _s.right0, _s.mtNeg5PX, _s.mrNeg5PX].join(' ')}>
                <Counter count={s.get('unread_count')} max={99} />
              </div>
            </NavLink>
          )
        })}

        {
          showSettings &&
          <Button
            circle
            backgroundColor='secondary'
            color='primary'
            onClick={this.handleOnOpenEditShortcutsModal}
            icon='cog'
            iconSize='18px'
            className={[_s.aiCenter, _s.jcCenter, _s.mr10, _s.h40PX, _s.w40PX].join(' ')}
          />
        }
      </div>
    )
  }

}

const mapStateToProps = (state, { type }) => {
  const allShortcuts = state.getIn(['shortcuts', 'items'])
  const shortcuts = !!type ? allShortcuts.filter((s) => s.get('shortcut_type') === type) : allShortcuts

  return {
    shortcuts,
    isError: state.getIn(['shortcuts', 'isError']),
    isLoading: state.getIn(['shortcuts', 'isLoading']),
  }
}

ShortcutsAvatarList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  shortcuts: ImmutablePropTypes.list,
}

export default connect(mapStateToProps)(ShortcutsAvatarList)